/* eslint-disable react-refresh/only-export-components */
// This file exports both data and simple image components by design
// Fast refresh limitation is acceptable for this data file

import type { ComponentType } from 'react'

interface IconProps {
  className?: string
  width?: number | string
  height?: number | string
}

export interface LettersItem {
  word: string
  Svg: ComponentType<IconProps>
}

const CatImg = (props: IconProps) => (
  <img src="/images/cvc/cat.gif" alt="" role="presentation" {...props} />
)

const DogImg = (props: IconProps) => (
  <img src="/images/cvc/dog.gif" alt="" role="presentation" {...props} />
)

const SunImg = (props: IconProps) => (
  <img src="/images/cvc/sun.gif" alt="" role="presentation" {...props} />
)

const HatImg = (props: IconProps) => (
  <img src="/images/cvc/hat.gif" alt="" role="presentation" {...props} />
)

const BusImg = (props: IconProps) => (
  <img src="/images/cvc/bus.gif" alt="" role="presentation" {...props} />
)

const PigImg = (props: IconProps) => (
  <img src="/images/cvc/pig.gif" alt="" role="presentation" {...props} />
)

const BatImg = (props: IconProps) => (
  <img src="/images/cvc/bat.gif" alt="" role="presentation" {...props} />
)

export const LETTERS_ITEMS: LettersItem[] = [
  { word: 'cat', Svg: CatImg },
  { word: 'dog', Svg: DogImg },
  { word: 'sun', Svg: SunImg },
  { word: 'hat', Svg: HatImg },
  { word: 'bus', Svg: BusImg },
  { word: 'pig', Svg: PigImg },
  { word: 'bat', Svg: BatImg },
]

export const LETTERS_PREVIEW_COUNT = 7
